import React from 'react'

import {
  Root,
  StateDot,
  PreviewWrapper,
  TypeIconOverlay,
  Content,
  Title,
  Subtitle,
  Meta,
  Timeago,
  Actions,
} from './InboxListItem.styles'

export type InboxListItemState = 'read' | 'unread'

export interface InboxListItemProps {
  /** Read state — drives the leading unread indicator. */
  state: InboxListItemState
  /** Square preview of the notification's subject (document, folder, workspace). */
  preview: React.ReactNode
  /** Small badge overlaid on the preview, representing the action type. */
  typeIcon?: React.ReactNode
  title: React.ReactNode
  subtitle: React.ReactNode
  /** Relative time, e.g. "1w", "2d". Hidden on hover when actions are revealed. */
  timeago?: React.ReactNode
  /** Optional type-specific action(s) rendered on the right. */
  extraActions?: React.ReactNode
  active?: boolean
}

export const InboxListItem = ({
  state,
  preview,
  typeIcon,
  title,
  subtitle,
  timeago,
  extraActions,
  active,
}: InboxListItemProps) => {
  return (
    <Root aria-selected={active}>
      <StateDot $visible={state === 'unread'} aria-label="Unread" />

      <PreviewWrapper>
        {preview}
        {typeIcon && <TypeIconOverlay aria-hidden>{typeIcon}</TypeIconOverlay>}
      </PreviewWrapper>

      <Content>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Content>

      <Meta>
        {timeago && <Timeago>{timeago}</Timeago>}
        {extraActions && (
          <Actions onClick={e => e.stopPropagation()}>{extraActions}</Actions>
        )}
      </Meta>
    </Root>
  )
}
